import React from 'react';
import { useFreight } from 'useStores/useFreight';
import UsersDialog from 'components/Dialog/UsersDialog/UsersDialog';

const FreightsModal = () => {
  const setChoosedFreight = useFreight((state) => state.setChoosedFreight);
  const openFreightsModal = useFreight((state) => state.freightsModal);
  const setOpenFreightsModal = useFreight(
    (state) => state.setOpenFreightsModal
  );

  const handleCloseOperatorDialog = (data) => {
    setOpenFreightsModal(false);
  };
  const handleSelectFreight = (data) => {
    setChoosedFreight(data?.[0]);
  };

  return (
    <UsersDialog
      single
      placeholder={'انتخاب باربری:'}
      role={['freight']}
      onChange={handleSelectFreight}
      open={openFreightsModal}
      closeDialog={handleCloseOperatorDialog}
    />
  );
};

export default FreightsModal;
